import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@/Assets/fonts/satoshi/css/satoshi.css';
import '@/Assets/fonts/aeonikPro/aeonikPro.css';
import '@/Assets/fonts/joystix/joystix.css';
import './index.css';
import './var.css';
import { stage } from './Config/ApiConfig';
import registerServiceWorker from './serviceWorkers';
import Hotjar from '@hotjar/browser';
import { HOTJAR_ID } from './Config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (stage === 'production') {
  require('./tag');
}

if (HOTJAR_ID) {
  Hotjar.init(+HOTJAR_ID, 6);
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
